import { Container } from '@styles/helpers';
import { tablet } from '@styles/mixins';
import axios from 'axios';
import React from 'react'
import styled, { css } from 'styled-components';

export default class ErrorBoundary extends React.Component<{}, { hasError: boolean }> {
    constructor(props: any) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error) {
        return { hasError: true };
    }

    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        axios.post('/api/log', { message: error.message, stack: errorInfo.componentStack, url: window.location.pathname })
    }

    render() {
        if (this.state.hasError) {
            return (
                <ErrorBoundaryContainer>
                    <h1 className="h2">Sorry, an unexpected error has happened.</h1>
                    <p style={{ maxWidth: "320px" }}>We will fix the issue soon. You can try to refresh the page or visit other pages.</p>
                </ErrorBoundaryContainer>
            )
        }

        return this.props.children
    }
}

const ErrorBoundaryContainer = styled(Container)`
    padding-top: 30px;
    padding-bottom: 30px;
    max-width: 800px;
    margin: 0 auto 0 0;

    ${tablet(css`
        padding-top: 60px;
        padding-bottom: 60px;
    `)}
`